<template>
  <div class="content-item flex">
    <div class="content-item-label">是否为处方药</div>
    <el-radio-group v-model="radio" class="flex align-items-center">
      <el-radio label="1">处方药</el-radio>
      <el-radio label="2">非处方药</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: "PrescriptionDrugs",
  props: ['prescriptionDrug'],
  computed: {
    radio: {
      get() {
        return this.prescriptionDrug
      },
      set(val) {
        this.$emit('update:prescriptionDrug',val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
